import {Component} from '@angular/core';

import {ControlWidget} from '../../widget';

@Component({
  selector: 'sf-select-widget',
  templateUrl: './sf-select-widget.component.html'
})
export class SelectWidgetComponent extends ControlWidget {
}



// WEBPACK FOOTER //
// ./src/app/schema-form/components/defaultwidgets/select/sf-select-widget.component.ts